import { render, staticRenderFns } from "./NewCommandRouterChooser.vue?vue&type=template&id=19995281&"
import script from "./NewCommandRouterChooser.vue?vue&type=script&lang=ts&"
export * from "./NewCommandRouterChooser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports